import React, {useContext, useEffect, useRef, useState} from 'react';
import {View, SectionList} from 'react-native';
import moment from 'moment';

import DashedDivider from '../../elements/DashedDivider';
import Text from '../../elements/Text';
import BuyAgainCard from '../BuyAgainCard';

import styles from './styles';
import {useTheme} from '../../../theme';
import {useNavigation} from '@react-navigation/native';
import {loadingPauseContext} from '../../../contexts/LoadingPauseContext';
import {errorStatusContext} from '../../../contexts/ErrorStatusContext';
import {fetchApi} from '../../../utils/ApiHelper';
import {HTTP_METHODS, PRODUCTS_BUY_AGAIN} from '../../../utils/URLConstants';
import {DLog} from '../../../utils/HelperMethods';
import {EmptyFeed} from '../../../utils/SvgIcons';

const BuyAgainProduct = ({
  searchTerm,
  searchFilterEnabled,
  selectedFilters,
  setSearchFilterEnabled,
  setSelectedFilters,
}) => {
  const navigation = useNavigation();
  const {colors} = useTheme();

  const [pageSize, setPageSize] = useState(1000);
  const [currentPage, setCurrentPage] = useState(1);
  const [rows, setRows] = useState([]);

  const didLoad = useRef(false);
  const searchTimeout = useRef(null);

  const lpc = useContext(loadingPauseContext);
  const esc = useContext(errorStatusContext);

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- fetch only on page change; getData is recreated each render and would refetch on every render
  }, [currentPage]);

  const getData = () => {
    const tagArrayForAPI = ['all', 'freeForMe'];
    let params = {
      page: currentPage,
      size: pageSize,
    };
    if (selectedFilters && selectedFilters.length > 0) {
      let priceRange = selectedFilters[0];
      let tag = selectedFilters[1];
      if (priceRange.length > 0) {
        params['startPriceRange'] = priceRange[0];
        params['endPriceRange'] = priceRange[1];
      }
      if (tag.length > 0) {
        params['type'] = tagArrayForAPI[tag];
      }
    }
    if (searchTerm && searchTerm.length > 0) {
      params['search'] = searchTerm;
    }

    lpc.setVisible(true);
    fetchApi(HTTP_METHODS.GET, PRODUCTS_BUY_AGAIN, null, params)
      .then(res => {
        // lpc.setVisible(false);
        let list = res.data.data.rows;
        // DLog(JSON.stringify(list));
        const groupByDate = list.reduce((group, product) => {
          const {orderInvoiceDate} = product.order;
          group[orderInvoiceDate] = group[orderInvoiceDate] ?? [];
          group[orderInvoiceDate].push(product);
          return group;
        }, {});

        let finalArray = Object.keys(groupByDate).map(item => {
          return {title: item, data: groupByDate[item]};
        });
        setRows(finalArray);
        didLoad.current = true;
      })
      .catch(err => {
        // DLog(err);
        didLoad.current = true;
        lpc.setVisible(false);
        esc.showError(err);
      });
  };

  useEffect(() => {
    if (didLoad.current) {
      setSearchFilterBool('');
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- refetch only when filters change; getData/setSearchFilterBool are recreated each render
  }, [selectedFilters]);

  useEffect(() => {
    if (didLoad.current) {
      if (searchTimeout.current) {
        clearTimeout(searchTimeout.current);
        searchTimeout.current = null;
      }

      searchTimeout.current = setTimeout(() => {
        setSearchFilterBool(searchTerm);
        getData();
      }, 800);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- debounced fetch keyed to searchTerm only; adding per-render getData/setSearchFilterBool would bypass the debounce
  }, [searchTerm]);

  const setSearchFilterBool = searchText => {
    if (
      (searchText && searchText.length > 0) ||
      (selectedFilters && selectedFilters.length > 0)
    ) {
      if (!searchFilterEnabled) {
        setSearchFilterEnabled(true);
      }
    } else {
      if (searchFilterEnabled) {
        setSearchFilterEnabled(false);
      }
    }
  };

  const renderEmptyListView = () => {
    return (
      <View style={styles.emptyListContainer}>
        <EmptyFeed />
      </View>
    );
  };

  const renderItem = ({item, index}) => {
    return <BuyAgainCard item={item} index={index} />;
  };

  const renderSectionHeader = ({section: {title}}) => {
    return (
      <View style={styles.sectionHeaderStyle}>
        <View style={styles.flex1}>
          <DashedDivider />
        </View>
        <Text
          variation="Text1Regular"
          color={colors.textDisabled}
          style={styles.marginHorizontal8}>
          {moment(title).format('MM/DD/YYYY')}
        </Text>
        <View style={styles.flex1}>
          <DashedDivider />
        </View>
      </View>
    );
  };

  return (
    <View style={styles.flex1}>
      <SectionList
        stickySectionHeadersEnabled={false}
        sections={rows}
        keyExtractor={(item, index) => String(item.product?.id || index)}
        renderItem={renderItem}
        contentContainerStyle={styles.paddingBottom24}
        renderSectionHeader={renderSectionHeader}
        ListEmptyComponent={renderEmptyListView}
      />
    </View>
  );
};

export default BuyAgainProduct;
